export default class DOMHelper {

  static isChildOfElementWithClass(childElement, className) {
    var parent = childElement.parentNode;

    while (parent != null) {
      if (parent.nodeName === "DIV" && parent.classList.contains(className)) {
        return true;
      }
      parent = parent.parentNode;
    }
    return false;
  }
}
